export default __webpack_public_path__ + "static/media/prize_2.min.c0a83a57.png";